// extracted by mini-css-extract-plugin
export default {"line":"styles_line__PmOwf","label":"styles_label__ipAKX"};